document.addEventListener('DOMContentLoaded', function () {
  const downloadButton = document.getElementById('final-download-pdf');

  if (!downloadButton) {
    console.warn('Download button not found. PDF generation script exiting.');
    return;
  }

  downloadButton.addEventListener('click', async function () {
    // Use the PCBuilderState data structure from your existing code
    const components = [];
    let totalPriceInclusive = 0; // Total price including GST

    // GST rate (18%)
    const gstRate = 0.18;
    const gstMultiplier = 1 + gstRate; // 1.18

    // Helper function for fallback component names
    function getComponentDisplayName(component) {
      const displayNames = {
        'cabinet': 'Cabinet',
        'motherboard': 'Motherboard',
        'gpu': 'Graphics Card',
        'ram': 'RAM',
        'smps': 'PSU',
        'primaryStorage': 'SSD',
        'secondaryStorage': 'HDD',
        'optionalStorage': 'HDD',
        'cooler': 'Cooler',
        'wifi': 'WIFI',
        'os': 'Operating System'
      };
      return displayNames[component] || component;
    }

    // Process components using your existing logic
    if (window.PCBuilderState) {
      Object.keys(window.PCBuilderState).forEach(component => {
        const componentData = window.PCBuilderState[component];
        if (component === 'customMods' || !componentData || typeof componentData !== 'object') {
          return;
        }

        let selectedText = '';
        let priceInclusive = 0;
        let brandName = '';

        if (component === 'processor' && componentData.model) {
          brandName = componentData.brand?.name || 'Processor';
          const generation = componentData.generation?.name || '';
          const model = componentData.model?.name || '';
          selectedText = `${generation} ${model}`.trim();
          priceInclusive = window.PCBuilderState.validatePrice(componentData.model.price || componentData.model.selling_price || 0);
        } else if ((component.includes('storage') || component === 'cooler') && componentData.model) {
          brandName = componentData.brand?.name || getComponentDisplayName(component);
          const type = componentData.type?.name || '';
          const model = componentData.model?.name || '';
          selectedText = `${type} ${model}`.trim();
          priceInclusive = window.PCBuilderState.validatePrice(componentData.model.price || componentData.model.selling_price || 0);
        } else if (componentData.model) {
          brandName = componentData.brand?.name || getComponentDisplayName(component);
          const model = componentData.model?.name || '';
          selectedText = model.trim();
          priceInclusive = window.PCBuilderState.validatePrice(componentData.model.price || componentData.model.selling_price || 0);
        }

        if (selectedText && priceInclusive >= 0) {
          // Calculate GST-exclusive price without rounding
          const priceExclusive = priceInclusive / gstMultiplier;
          const componentDisplayName = getComponentDisplayName(component);
          const displayName = brandName && brandName !== componentDisplayName && brandName !== component
            ? `${componentDisplayName}${" "}- ${" "}${brandName}`
            : componentDisplayName;

          components.push({
            name: displayName,
            model: selectedText,
            priceInclusive: priceInclusive,
            priceExclusive: priceExclusive
          });
          totalPriceInclusive += priceInclusive;
        }
      });

      // Process custom mods
      if (window.PCBuilderState.customMods && Array.isArray(window.PCBuilderState.customMods)) {
        window.PCBuilderState.customMods.forEach((mod, index) => {
          if (mod.model) {
            const category = mod.category?.name || '';
            const brand = mod.brand?.name || 'Custom Mod';
            const model = mod.model?.name || '';
            const selectedText = `${category} ${model}`.trim();
            const priceInclusive = window.PCBuilderState.validatePrice(mod.model.price || mod.model.selling_price || 0);

            if (priceInclusive > 0) {
              const priceExclusive = priceInclusive / gstMultiplier;

              components.push({
                name: brand,
                model: selectedText,
                priceInclusive: priceInclusive,
                priceExclusive: priceExclusive
              });
              totalPriceInclusive += priceInclusive;
            }
          }
        });
      }
    }

    // Calculate totals
    const subtotalExclusive = components.reduce((sum, c) => sum + c.priceExclusive, 0);
    const totalGstAmount = totalPriceInclusive - subtotalExclusive;

    // Prepare data object for HTML generation
    const configurationData = {
      components: components,
      subtotalExclusive: subtotalExclusive,
      totalGstAmount: totalGstAmount,
      totalPriceInclusive: totalPriceInclusive,
      companyInfo: {
        address: '405, Manjusha Building No. 57 Nehru Place, New Delhi - 110019',
        email: 'info@bitkart.in',
        contact: '9810742763 / 9810042763',
        gstin: '07AAXFB4740R1ZK',
        date: new Date().toLocaleDateString('en-GB')
      }
    };

    // Generate HTML and trigger print (works on mobile + desktop)
    generatePrintableHTML(configurationData);
  });

  // Function to generate HTML and trigger print - UNIVERSAL SOLUTION
  function generatePrintableHTML(data) {
    // Create the HTML structure with data
    const htmlContent = `
<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>BITKART Invoice</title>
    <script src="https://cdn.tailwindcss.com"></script>
    <script>
      tailwind.config = {
        theme: {
          extend: {
            colors: {
              "purple-start": "#8B2CB8",
              "purple-end": "#9B3CC8",
            },
            width: {
              a4: "794px",
            },
            height: {
              a4: "1123px",
            },
          },
        },
      };
    </script>
    <style>
    @media print {
     @page {
    margin: 10mm 5mm 0mm 5mm !important; 
    size: A4;
  }
    
  body {
    -webkit-print-color-adjust: exact;
    color-adjust: exact; 
    print-color-adjust: exact;
    padding-top: 50px !important;
    margin: 0;
    overflow: hidden !important;
    font-family: 'Gotham SSm', sans-serif !important;
  }
  
  header {
    position: fixed;
    top: 15px;
    left: 20px;
    right: 20px;
    height: 80px;
    z-index: 1000;
    background: white;
    padding-bottom: 5px;
  }
  
  .invoice-container {
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
    print-color-adjust: exact;
    margin-top: 0;
    padding-top: 0;
  }
  
  table, th, td {
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
    print-color-adjust: exact;
  }
  
  /* Hide print button during print */
  .print-button-container {
    display: none;
  }
}

/* Print button styling for screen display */
.print-button-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
}

.print-button {
  background: #800be5;
  color: white;
  border: none;
  padding: 14px 28px;
  border-radius: 8px;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(139, 44, 184, 0.3);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.print-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(139, 44, 184, 0.4);
  background: linear-gradient(135deg, #7A1FA7 0%, #8A2BB7 100%);
}

.print-button:active {
  transform: translateY(0);
}

.print-icon {
  font-size: 18px;
}
    </style>
  </head>
  <body class="bg-gray-100 p-0 m-0 text-base">
    <!-- Print Button - Fixed Position -->
    <div class="print-button-container">
      <button onclick="window.print()" class="print-button">
        <span class="print-icon">🖨️</span>
        <span>Save as PDF / Print</span>
      </button>
    </div>

    <div class="invoice-container w-[794px] min-h-[1123px] mx-auto bg-white px-5 py-2">
      <header>
        <img src="https://cdn.shopify.com/s/files/1/0655/8698/7217/files/bitkart.png?v=1758271732" alt="BITKART Logo" class="w-[100px] h-[100px] object-contain" />
      </header>

      <table class="bg-[#EAEAE9] w-full mt-10 rounded-md mb-[12px]">
        <tbody>
          <tr>
            <td class="pt-[15px] pl-[15px] pr-[15px] align-top leading-tight font-medium text-[10px] w-[20%]">Address</td>
            <td class="pt-[15px] pl-[10px] pr-[15px] align-top leading-tight w-[80%] text-[10px] font-medium">${data.companyInfo.address}</td>
          </tr>
          <tr>
            <td class="pl-[15px] pr-[15px] align-top leading-tight font-medium text-[10px] w-[20%]">Email</td>
            <td class="pl-[10px] pr-[15px] align-top leading-tight w-[80%] font-medium text-[10px]">${data.companyInfo.email}</td>
          </tr>
          <tr>
            <td class="pl-[15px] pr-[15px] align-top leading-tight font-medium w-[20%] text-[10px]">Contact Number</td>
            <td class="pl-[10px] pr-[15px] align-top leading-tight w-[80%] font-medium text-[10px]">${data.companyInfo.contact}</td>
          </tr>
          <tr>
            <td class="pl-[15px] pr-[15px] align-top leading-tight font-medium w-[20%] text-[10px]">Date</td>
            <td class="pl-[10px] pr-[15px] align-top leading-tight w-[80%] font-medium text-[10px]">${data.companyInfo.date}</td>
          </tr>
          <tr>
            <td class="pb-[15px] pl-[15px] pr-[10px] align-top leading-tight font-medium w-[20%] text-[10px]">GSTIN/UIN</td>
            <td class="pb-[15px] pl-[10px] pr-[10px] align-top leading-tight w-[80%] font-medium text-[10px]">${data.companyInfo.gstin}</td>
          </tr>
        </tbody>
      </table>

      <div class="bg-[#800be5] text-white py-2 text-[11px] text-center font-bold tracking-wide mb-0">
        CUSTOM BUILD CONFIGURATION
      </div>

      <table class="w-full border-collapse avoid-break">
        <thead>
          <tr>
            <th class="w-[24%] bg-[#eeeeee] px-2 border border-l-[1px] border-r-[1px] border-b-[1px] border-r-[#636363] border-l-[#636363] border-t-transparent border-b-[#636363] font-bold text-center text-[10px]">Component</th>
            <th class="w-[66%] bg-[#eeeeee] px-2 border border-l-[1px] border-r-[1px] border-b-[1px] border-r-[#636363] border-l-[#636363] border-t-transparent border-b-[#636363] font-bold text-center text-[10px]">Model</th>
            <th class="w-[10%] bg-[#eeeeee] px-2 border border-l-[1px] border-r-[1px] border-b-[1px] border-r-[#636363] border-l-[#636363] border-t-transparent border-b-[#636363] font-bold text-center text-[10px]">Unit Price</th>
          </tr>
        </thead>
        <tbody>
          ${data.components.map((component, index) => `
          <tr class="odd:bg-white even:bg-[#EAEAE9]">
            <td class="px-2 py-1 border-l-[1px] border-r-[1px] border-r-[#636363] border-l-[#636363] border-t-transparent border-t-[1px] font-bold capitalize align-top text-[10px] leading-tight">${component.name}</td>
            <td class="px-2 py-1 border-l-[1px] border-r-[1px] border-r-[#636363] border-l-[#636363] border-t-transparent border-t-[1px] align-top capitalize font-medium text-[10px] leading-tight">${component.model}</td>
            <td class="px-2 py-1 border-l-[1px] border-r-[1px] border-r-[#636363] border-l-[#636363] border-t-transparent border-t-[1px] align-top font-bold text-[10px] cpa leading-tight text-right">${component.priceExclusive.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
          </tr>
          `).join('')}
                    <tr class="odd:bg-white even:bg-[#EAEAE9]">
            <td class="px-2 py-1 border-l-[1px] border-r-[1px] border-r-[#636363] border-l-[#636363] border-t-transparent border-t-[1px] font-bold capitalize align-top text-[10px] leading-tight"> <span class=" block sm:inline">
  Premium Warranty Package (Worth
  <span class="line-through opacity-60">₹9,999</span>) - FREE 
</span></td>
          <td class="px-2 py-1 border-l-[1px] border-r-[1px] border-r-[#636363] border-l-[#636363] border-t-transparent border-t-[1px] align-top capitalize font-medium text-[10px] leading-tight">
  Includes expert telephonic/video troubleshooting and free pick-up &amp; drop anywhere in India in case of hardware failure.
  <span class="font-bold">3 YEARS</span>
</td>

            <td class="px-2 py-1 border-l-[1px] border-r-[1px] border-r-[#636363] border-l-[#636363] border-t-transparent border-t-[1px] align-top font-bold text-[10px] cpa leading-tight text-right">0.00</td>
          </tr>
          

          <tr class="odd:bg-white even:bg-[#eeeeee]">
            <td class="px-2 py-1 border-l border-r border-t-[1px] border-l-[#636363] border-r-[#636363] border-t-[#636363] text-[10px] font-bold" colspan="1">Subtotal</td>
            <td class="text-right px-2 py-1 border-l border-r border-t-[1px] border-l-[#636363] border-r-[#636363] border-t-[#636363] text-[10px] font-bold" colspan="2">${data.subtotalExclusive.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
          </tr>

          <tr class="odd:bg-white even:bg-[#EAEAE9]">
            <td class="font-medium px-2 py-1 border border-l-[1px] border-r-[1px] border-r-[#636363] border-l-[#636363] border-t-transparent border-b-transparent text-[10px]" colspan="1">GST (18%)</td>
            <td class="text-right px-2 py-1 border border-l-[1px] border-r-[1px] border-r-[#636363] border-l-[#636363] font-bold border-t-transparent border-b-transparent text-[10px]" colspan="2">${data.totalGstAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
          </tr>
          <tr class="odd:bg-white even:bg-[#EAEAE9]">
            <td class="font-medium px-2 py-1 border border-l-[1px] border-r-[1px] border-b-[1px] border-r-[#636363] border-l-[#636363] border-t-transparent border-b-[#636363] text-[10px]" colspan="1">Total Price</td>
            <td class="text-right px-2 py-1 border border-l-[1px] border-r-[1px] border-b-[1px] border-r-[#636363] font-bold border-l-[#636363] border-t-transparent border-b-[#636363] text-[10px]" colspan="2">INR ${data.totalPriceInclusive.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
          </tr>
        </tbody>
      </table>
      <div class="bg-[#333333] text-white text-center py-2 px-3 !font-gotham-Bold leading-relaxed text-[11px] mb-3">
      BITKART MACHINES COME WITH A 3 YEAR WARRANTY! (INCLUDES FREE PICK UP AND DROP) <br />
PACKING AND TRANSIT INSURANCE CHARGES ARE APPLICABLE ON DELIVERY
    </div>

      <div class="bg-[#800BE5] text-white py-2 rounded-t-[9px] text-center px-[11px] font-bold text-[11px] tracking-wide mb-0">
        QUOTATION TERMS AND CONDITIONS
      </div>
 
      <div class="bg-[#EAEAE9] w-full rounded-b-md pb-1 pt-2 px-0">
        <table class="w-full border-collapse mb-0 avoid-break mb-[20px]">
          <tbody>
            <tr>
              <td class="font-bold text-[10px] pl-6 pr-2 align-top w-[32%]">
                Inclusive Pricing
              </td>
              <td class="pl-2 font-bold text-[10px] pr-6 align-top w-[68%]">
                The total price quoted is inclusive of all applicable taxes and
                charges.
              </td>
            </tr>
            <tr>
              <td class="font-bold text-[10px] pl-6 pr-2 align-top">
                Validity of Quote
              </td>
              <td class="pl-2 font-bold text-[10px] pr-6 align-top">
                The quoted price is subject to change and is valid only until
                the date stated on the quotation.
              </td>
            </tr>
            <tr>
              <td class="font-bold text-[10px] pl-6 pr-2 align-top">
                Component Availability
              </td>
              <td class="pl-2 font-bold text-[10px] pr-6 align-top">
                The components listed in this quote are subject to availability
                at the time of purchase.
              </td>
            </tr>
            <tr>
              <td class="font-bold text-[10px] pl-6 pr-2 align-top">
                Custom Requirements
              </td>
              <td class="pl-2 font-bold text-[10px] pr-6 align-top">
                Should you require specific components or customizations, please
                feel free to contact us via email or phone.
              </td>
            </tr>
            <tr>
              <td class="font-bold text-[10px] pl-6 pr-2 align-top">Clarifications</td>
              <td class="pl-2 font-bold text-[10px] pr-6 align-top">
                If you are unsure about any information provided in this
                quotation, do not hesitate to reach out to us for clarification.
              </td>
            </tr>
            <tr>
              <td class="font-bold text-[10px] pl-6 pr-2 align-top">
                Further Breakdown
              </td>
              <td class="pl-2 font-bold text-[10px] pr-6 align-top">
                For a detailed breakdown or additional information, kindly
                contact us via email or phone.
              </td>
            </tr>
            <tr>
              <td class="font-bold text-[10px] pl-6 pr-2 align-top">
                Flexible Financing Options
              </td>
              <td class="pl-2 font-bold text-[10px] pr-6 align-top">
                We offer flexible finance options to make your purchase easier.
                Please contact us for more details.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
</div>
     <div class="invoice-container w-[794px] mt-12 mx-auto bg-white p-5">

    <div class="text-center bg-[#800be5] text-white font-bold text-lg mt-4 py-[10px]">WHAT SETS US APART?</div>

     <div class="features mt-4">
  <!-- Feature 1 -->
  <div class="mb-[14px]">
    <div class="w-[75%] bg-[#eaeaea] rounded-[16px] rounded-r-[9999px] flex items-center px-4 box-border">
      <div class="w-[75%] py-4 px-[18px]">
        <h3 class="text-[18px] font-bold text-[var(--text-dark)] m-0">Complete Transparency</h3>
        <p class="mt-2 text-[11px] leading-[1.5] text-black">
          We understand your concerns about authenticity and quality. That's why we provide live access to the unboxing and assembly process, ensuring you see exactly what goes into your custom PC.
        </p>
      </div>
      <div class="w-[25%] text-center py-2">
        <img src="https://cdn.shopify.com/s/files/1/0655/8698/7217/files/Transparancy.png?v=1760166711" alt="Transparency illustration" class="max-w-[240px] bg-transparent w-full h-auto object-contain" />
      </div>
    </div>
  </div>

  <!-- Feature 2 -->
  <div class="flex items-end justify-end mb-[14px]">
    <div class="w-[75%] bg-[#eaeaea] rounded-[16px] rounded-l-[9999px] flex items-center flex-row-reverse px-4 box-border">
      <div class="w-[75%] py-4 px-[18px]">
        <h3 class="text-[18px] font-bold text-[var(--text-dark)] m-0">End-to-End Solutions</h3>
        <p class="mt-2 text-[11px] leading-[1.5] text-black">
          From assembly to testing, every PC we deliver is fully optimized and ready to use straight out of the box.
        </p>
      </div>
      <div class="w-[25%] text-center py-2">
        <img src="https://cdn.shopify.com/s/files/1/0655/8698/7217/files/End_to_end.png?v=1760166730" alt="End-to-end illustration" class="max-w-[240px] bg-transparent w-full h-auto object-contain" />
      </div>
    </div>
  </div>

  <!-- Feature 3 -->
  <div class="mb-[14px]">
    <div class="w-[75%] bg-[#eaeaea] rounded-[16px] rounded-r-[9999px] flex items-center px-4 box-border">
      <div class="w-[75%] py-4 px-[18px]">
        <h3 class="text-[18px] font-bold text-[var(--text-dark)] m-0">Secured Shipping</h3>
        <p class="mt-2 text-[11px] leading-[1.5] text-black">
          Your PC is shipped in a fully insured, custom wooden case—guaranteeing safety and peace of mind until it reaches the doorstep.
        </p>
      </div>
      <div class="w-[25%] text-center py-2">
        <img src="https://cdn.shopify.com/s/files/1/0655/8698/7217/files/Packing_91510959-cab2-4414-a753-11adc5d95064.png?v=1760166484" alt="Shipping illustration" class="max-w-[240px] bg-transparent w-full h-auto object-contain" />
      </div>
    </div>
  </div>

  <!-- Feature 4 -->
  <div class="flex items-end justify-end mb-[14px]">
    <div class="w-[75%] bg-[#eaeaea] rounded-[16px] rounded-l-[9999px] flex items-center flex-row-reverse px-4 box-border">
      <div class="w-[75%] py-4 px-[18px]">
        <h3 class="text-[18px] font-bold text-[var(--text-dark)] m-0">Trusted Support & Warranty</h3>
        <p class="mt-2 text-[11px] leading-[1.5] text-black">
          Every Bitkart machine comes with 3 years of dedicated telephonic support and on-site warranty, regardless of the price—because trust matters most.
        </p>
      </div>
      <div class="w-[25%] text-center py-2">
        <img src="https://cdn.shopify.com/s/files/1/0655/8698/7217/files/warranty.png?v=1760166716" alt="Warranty illustration" class="max-w-[240px] w-full h-auto object-contain" />
      </div>
    </div>
  </div>
</div>
 
     <div class="flex gap-[18px] mt-4 mb-0 items-stretch justify-between">
  <!-- Google Reviews -->
  <a
    href="https://g.page/r/Ca0E3U7j4qzYEAI/review"
    target="_blank"
    rel="noopener"
    class="flex-1 bg-[#eaeaea] no-underline text-inherit flex flex-col overflow-hidden qr-card"
  >
    <img
      src="https://cdn.shopify.com/s/files/1/0655/8698/7217/files/Google_reviews.svg?v=1760177203"
      alt="Read our Google reviews"
      class="block w-full h-auto p-[14px] box-border bg-transparent qr-img"
    />
    <div
      class="bg-[#800be5] text-white text-center font-bold text-[11px] py-[10px] px-2 tracking-[0.02em] qr-cta"
    >
      READ OUR GOOGLE REVIEWS
    </div>
  </a>

  <!-- Social Media -->
  <a
    href="https://instagram.com/bitkart"
    target="_blank"
    rel="noopener"
    class="flex-1 bg-[#eaeaea] no-underline text-inherit flex flex-col overflow-hidden qr-card"
  >
    <img
      src="https://cdn.shopify.com/s/files/1/0655/8698/7217/files/Social_Media.svg?v=1760177203"
      alt="Find Bitkart on social media"
      class="block w-full h-auto p-[14px] box-border bg-transparent qr-img"
    />
    <div
      class="bg-[#800be5] text-white text-center font-bold text-[11px] py-[10px] px-2 tracking-[0.02em] qr-cta"
    >
      FIND BITKART ON SOCIAL MEDIA
    </div>
  </a>

  <!-- Google Maps -->
  <a
    href="https://maps.app.goo.gl/bitkart"
    target="_blank"
    rel="noopener"
    class="flex-1 bg-[#eaeaea] no-underline text-inherit flex flex-col overflow-hidden qr-card"
  >
    <img
      src="https://cdn.shopify.com/s/files/1/0655/8698/7217/files/Google_Maps.svg?v=1760177203"
      alt="Find us on Google Maps"
      class="block w-full h-auto p-[14px] box-border bg-transparent qr-img"
    />
    <div
      class="bg-[#800be5] text-white text-center font-bold text-[11px] py-[10px] px-2 tracking-[0.02em] qr-cta"
    >
      FIND US ON GOOGLE MAPS
    </div>
  </a>
</div>
    </div>
  </body>
</html>`;

    // Create blob URL for the HTML content
    const blob = new Blob([htmlContent], { type: 'text/html' });
    const blobUrl = URL.createObjectURL(blob);

    // Open in new tab using blob URL - bypasses most popup blockers
    const printWindow = window.open(blobUrl, '_blank');

    if (!printWindow) {
      // Ultimate fallback - hidden iframe method
      let printFrame = document.getElementById('bitkart-print-frame');
      
      if (!printFrame) {
        printFrame = document.createElement('iframe');
        printFrame.id = 'bitkart-print-frame';
        printFrame.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;';
        document.body.appendChild(printFrame);
      }
      
      const iframeDoc = printFrame.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(htmlContent);
      iframeDoc.close();
    }

    // Clean up blob URL after a delay
    setTimeout(() => {
      URL.revokeObjectURL(blobUrl);
    }, 5000);
  }
});

// WhatsApp share functionality
document.addEventListener('DOMContentLoaded', function () {
  const waBtn = document.getElementById('share-on-whatsapp');
  if (!waBtn) return;

  waBtn.addEventListener('click', function (e) {
    e.preventDefault();

    const rows = [];
    let totalInclusive = 0;
    const gstRate = 0.18;
    const gstMultiplier = 1 + gstRate;

    function getComponentDisplayName(component) {
      const displayNames = {
        cabinet: 'Cabinet',
        motherboard: 'Motherboard',
        gpu: 'Graphics Card',
        ram: 'RAM',
        smps: 'PSU',
        primaryStorage: 'SSD',
        secondaryStorage: 'HDD',
        optionalStorage: 'HDD',
        cooler: 'Cooler',
        wifi: 'WIFI',
        os: 'Operating System'
      };
      return displayNames[component] || component;
    }

    if (window.PCBuilderState) {
      Object.keys(window.PCBuilderState).forEach((component) => {
        const data = window.PCBuilderState[component];
        if (component === 'customMods' || !data || typeof data !== 'object') return;

        let model = '';
        let priceIncl = 0;
        let brand = '';

        if (component === 'processor' && data.model) {
          brand = data.brand?.name || 'Processor';
          const gen = data.generation?.name || '';
          const mdl = data.model?.name || '';
          model = `${gen} ${mdl}`.trim();
          priceIncl = window.PCBuilderState.validatePrice(data.model.price || data.model.selling_price || 0);
        } else if ((component.includes('storage') || component === 'cooler') && data.model) {
          brand = data.brand?.name || getComponentDisplayName(component);
          const type = data.type?.name || '';
          const mdl = data.model?.name || '';
          model = `${type} ${mdl}`.trim();
          priceIncl = window.PCBuilderState.validatePrice(data.model.price || data.model.selling_price || 0);
        } else if (data.model) {
          brand = data.brand?.name || getComponentDisplayName(component);
          model = (data.model?.name || '').trim();
          priceIncl = window.PCBuilderState.validatePrice(data.model.price || data.model.selling_price || 0);
        }

        if (model) {
          const compName = getComponentDisplayName(component);
          const displayName = brand && brand !== compName && brand !== component ? `${compName} - ${brand}` : compName;
          const priceExcl = priceIncl / gstMultiplier;
          rows.push({ component: displayName, model, priceExcl });
          totalInclusive += priceIncl;
        }
      });

      if (Array.isArray(window.PCBuilderState.customMods)) {
        window.PCBuilderState.customMods.forEach((mod) => {
          if (!mod?.model) return;
          const category = mod.category?.name || '';
          const brand = mod.brand?.name || 'Custom Mod';
          const mdl = mod.model?.name || '';
          const model = `${category} ${mdl}`.trim();
          const priceIncl = window.PCBuilderState.validatePrice(mod.model.price || mod.model.selling_price || 0);
          if (priceIncl > 0) {
            const priceExcl = priceIncl / gstMultiplier;
            rows.push({ component: brand, model, priceExcl });
            totalInclusive += priceIncl;
          }
        });
      }
    }

    const subtotalExclusive = rows.reduce((s, r) => s + r.priceExcl, 0);
    const gstAmount = totalInclusive - subtotalExclusive;

    let message = '';
    message += 'Bitkart Custom Build (excl. GST)\n';
    message += 'Component\tModel\tUnit Price\n';
    rows.forEach((r) => {
      const price = r.priceExcl.toFixed(2);
      const model = r.model.length > 80 ? r.model.slice(0, 77) + '...' : r.model;
      message += `${r.component}\t${model}\t${price}\n`;
    });
    message += '\n';
    message += `Subtotal (excl. GST): ${subtotalExclusive.toFixed(2)}\n`;
    message += `GST (18%): ${gstAmount.toFixed(2)}\n`;
    message += `Total (incl. GST): ${totalInclusive.toFixed(2)}\n`;

    const url = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  });
});
